(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-3"] && !Shopify.designMode) return;
  try {
     
$(document).ready(function () {
  var div = $('.about-3 .media-col');
  function calculateDistances() {
    var divOffset = div.offset();
    var divWidth = div.width();
    var scrollLeft = $(window).scrollLeft();
    var distance = divOffset.left - scrollLeft; 
    $('.about-3 .vid').css({
      'left': '-' + distance + 'px',
      'width': distance + divWidth + 90 
    });
  }
  calculateDistances();
  $(window).on('load', calculateDistances);
  $(window).on('resize', calculateDistances);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
     
$( document ).ready(function() {
  const $slider = $('.brands .slider');
  $slider.slick({ 
    infinite: true,
    //variableWidth: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.brands .arrow-left').click(function () {
    $slider.slick('slickPrev');
  });
  $('.brands .arrow-right').click(function () {
    $slider.slick('slickNext');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
$(document).on('click', '.globo-form button[type="submit"]', function(e) {
  const form = $(this).closest('.globo-form')
  const email1 = form.find('input[name="email-1"]')
  if (email1.length) {
    const email = form.find('input[name="email"]')
    const wrapper = email1.closest('.globo-form-input')
    const messages = wrapper.siblings('small.messages')
    if (email1.val() !== email.val()) {
      e.preventDefault()
      messages.html('<p class="help-block error custom">Email does not match</p>')
    } else {
      messages.find('p.custom').remove()
    }
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-1"] && !Shopify.designMode) return;
  try {
     
$( document ).ready(function() { 
  const $slider = $('.custom-1 .slider');
  const $counter = $('.custom-1 .controls .counter');
  const totalSlides = $slider.find('.slide').length;

  $slider.slick({
    infinite: true,
    slidesToShow: 1,
    arrows: false
  });

  function updateCounter(currentSlide) {
    const current = currentSlide + 1;
    $counter.text(`${current}/${totalSlides}`);
  }
  updateCounter(0);
  $slider.on('afterChange', function (event, slick, currentSlide) {
    updateCounter(currentSlide);
  });
  $('.custom-1 .arrow-left').click(function () {
    $slider.slick('slickPrev');
  });
  $('.custom-1 .arrow-right').click(function () {
    $slider.slick('slickNext');
  });

  
  var divLeft = $('.custom-1 .content');
  var div = $('.custom-1 .media-col');
  function calculateDistances() {
    var divOffset = divLeft.offset();
    var divWidth = div.width();
    var scrollLeft = $(window).scrollLeft();
    var distance = divOffset.left - scrollLeft; 
    $('.custom-1 .slider-wrap').css({
      'width': distance + divWidth + 90 
    });
  }
  calculateDistances();
  $(window).on('load', calculateDistances);
  $(window).on('resize', calculateDistances);
  
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
     
function arrows() {
  var $w = $('.featured-collections .content').outerWidth();
  if ( Math.max( $(window).width(), window.innerWidth) > 800 ) { 
    $('.featured-collections .controls').css('left', $w - 110);
  } else {
      $('.featured-collections .controls').css('left', ($w / 2));
  }
}
  
$(document).ready(function() {
  const $slider = $('.featured-collections .slider');
  $slider.on('init', function(event, slick) {
    arrows();
  })
  $slider.slick({ 
    infinite: true,
    variableWidth: true,
    adaptiveHeight: true,
    arrows: false
  });
  $('.featured-collections .arrow-left').click(function () {
    $slider.slick('slickPrev');
  });
  $('.featured-collections .arrow-right').click(function () {
    $slider.slick('slickNext');
  }); 
});
  
$(window).resize(function() {
  arrows();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelector('.play-overlay').addEventListener('click', function() {
  const vidEmbed = this.closest('.vid-embed');
  const video = vidEmbed.querySelector('video');
  video.controls = true;
  video.play();
  this.classList.add('done');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
     
function activeCollection() {
  $('.collection-cols > .sidebar .expand-btn').each(function() {
    if ($(this).children('a.active').length > 0) {
      $(this).addClass('expanded');
    }
  });
}
  
$(document).ready(function() { 
  activeCollection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
     
function activeCollection() {
  $('.collection-cols > .sidebar .expand-btn').each(function() {
    if ($(this).children('a.active').length > 0) {
      $(this).addClass('expanded');
    }
  });
}
  
$(document).ready(function() { 
  activeCollection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
$(document).ready(function() {
  // Smart Stencils
  var searchParams = new URLSearchParams(window.location.search);
  var suid = searchParams.get("suid");
  if (suid) {
   $('#suid').val(suid);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["router"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var searchParams = new URLSearchParams(window.location.search);
    var upc = searchParams.get("upc")?.toUpperCase();
    var suid = searchParams.get("suid");
    var titleElement = document.querySelector(".router h1");
    var contentElement = document.querySelector(".router p");
    var buttonElement = document.querySelector(".router .button");
    if (upc) {
      var allVariants = [];
      var currentPage = 1;
      var batchSize = 50;
      function fetchVariants(page) {
        var offset = (page - 1) * batchSize;
        fetch(`/collections/all/products.json?limit=${batchSize}&page=${page}`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            data.products.forEach(product => {
              product.variants.forEach(variant => {
                var variantData = {
                  'sku': variant.sku,
                  'id': variant.id,
                  'title': variant.title,
                  'product_handle': product.handle
                };
                allVariants.push(variantData);
              });
            });
            if (data.products.length === batchSize) {
              currentPage++;
              fetchVariants(currentPage);
            } else {
              findVariantMatch();
            }
          })
          .catch(error => {
            console.error("Error fetching products:", error);
            titleElement.innerHTML = titleElement.getAttribute("data-title-fail");
            contentElement.innerHTML = contentElement.getAttribute("data-content-fail");
            buttonElement.style.display = 'inline-block';
          });
      }
      function findVariantMatch() {
        for (var i = 0; i < allVariants.length; i++) {
          var variant = allVariants[i];
          if (!variant.sku) {
            console.log('No SKU provided, showing variant name:', variant.title);
          } else {
            console.log('Checking variant SKU:', variant.sku);
          }
          if (variant.sku && variant.sku.toUpperCase() === upc) {
            console.log("Matching variant found:", variant);
            var redirectUrl = "/products/" + variant.product_handle + "?variant=" + variant.id + 
                  "&suid=" + suid +
                  "&utm_source=qr" + 
                  "&utm_content=" + variant.id + 
                  "&utm_term=" + variant.sku +
                  "&utm_medium=direct";
            console.log("Redirecting to:", redirectUrl);
           
            titleElement.innerHTML = titleElement.getAttribute("data-title-success");
            contentElement.innerHTML = contentElement.getAttribute("data-content-success");
            buttonElement.innerHTML = "Go To Stencil";
            buttonElement.setAttribute('href', redirectUrl);
            buttonElement.style.display = 'inline-block';
            var countdownSpan = document.querySelector(".router p span");
            var countdown = parseInt(countdownSpan.textContent) || 10;
            function updateCountdown() {
              countdownSpan.textContent = countdown;
              if (countdown === 0) {
                  window.location.href = redirectUrl;
              } else {
                  countdown--;
                  setTimeout(updateCountdown, 1000);
              }
            }
            updateCountdown();
            return;
          }
        }
        console.log("No matching variant found for UPC:", upc);
        titleElement.innerHTML = titleElement.getAttribute("data-title-fail");
        contentElement.innerHTML = contentElement.getAttribute("data-content-fail");
        buttonElement.style.display = 'inline-block';
      }
      fetchVariants(currentPage);
    } else {
      titleElement.innerHTML = titleElement.getAttribute("data-title-fail");
      contentElement.innerHTML = contentElement.getAttribute("data-content-fail");
      buttonElement.style.display = 'inline-block';
    }
  }, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"] && !Shopify.designMode) return;
  try {
     
function inputCenter() {
  $('.subscribe form .field__label').width($('.subscribe .field').width() - $('.subscribe button').outerWidth());
  console.log($('.subscribe button').outerWidth());
  console.log($('.subscribe .field').width()); 
}
  
$(document).ready(function() { 
  inputCenter();
});
  
$(window).resize(function() {
  inputCenter();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
     
$( document ).ready(function() {
  const $slider = $('.testimonials .slider')
  $slider.slick({ 
    infinite: true,
    //variableWidth: true,
    slidesToShow: 1,
    arrows: false
  });
  $('.testimonials .arrow-left').click(function () {
    $slider.slick('slickPrev');
  });
  $('.testimonials .arrow-right').click(function () {
    $slider.slick('slickNext');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $('.vid-embed').one('mouseenter', function () {
    $(this).addClass('play');
  });
});

  } catch(e) { console.error(e); }
})();
})();
